//
//
//
//
//
//
//
//
//

import PageUiMenu from '@/components/PageUi/Menu'
import PageFooter from '@/components/PageFooter'

import { ReactInVue } from 'vuera'

import * as fullPageCanvasPanelPlugin from './full-page-plugin.js';

export default {
  name: 'CanvasPanel',
  components: {
    PageFooter,
    PageUiMenu,
    'react-component': ReactInVue(fullPageCanvasPanelPlugin.FullPageViewer)

  },
  data () {
    return {
    }
  },
  props: {
    manifest: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Title'
    }
  },
  created() {
  },
  mounted() {
  }
}
